import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { PermissionService } from '../services/permission.service';
/**
 * This directive determines, if the current user can see (activate) the selected input (won't be there, if not).
 * Input must be the permission name.
 *
 * @example <input *canActivate="'user-update'" type="text" [(ngModel)]="model.email" class="form-control" name="email" required>
 * @export
 * @class CanActivateDirective
 */
@Directive({
  selector: '[canActivate]',
})
export class CanActivateDirective {
  @Input()
  set canActivate(permission: string) {
    this.permissionHandler(permission);
  }

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly service: PermissionService
  ) {
    this.service.permissionsChanged.subscribe(() => this.permissionHandler(this.permission));
  }

  /**
   * Name of the permission
   *
   * @private
   * @type {string}
   * @memberof CanEditDirective
   */
  private permission: string;

  /**
   * Determines if the name is negated.
   *
   * @private
   * @type {boolean}
   * @memberof CanEditDirective
   */
  private negative: boolean;

  private permissionHandler(permission: string) {
    this.viewContainer.clear();
    if (permission) {
      this.negative = permission.charAt(0) === '!';
      this.permission = this.negative ? permission.substr(1) : permission;
      if (this.negative) {
        this.service.canActivate(this.permission)
          ? this.viewContainer.clear()
          : this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.service.canActivate(this.permission)
          ? this.viewContainer.createEmbeddedView(this.templateRef)
          : this.viewContainer.clear();
      }
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
